// Liquid Women in Warcraft Support (Later renamed to Visage)

import { IQualifiedGuildRecruitmentTag } from '../sharedTypes';

export const QUALIFIED_GUILD_RECRUITMENT_TAGS: IQualifiedGuildRecruitmentTag[] = [
  {
    tagName: 'Visage Verified',
    tagId: 10504,

    // Display properties
    tagClass: 'rio-rec-tag--lwiw',
    tooltipLocKey: 'recruitment:visage.approved-tooltip.description',
    badgeLabelLocKey: 'recruitment:visage.badge-label',
    badgeImagePath: '/images/visage-verified/badge.png',
    badgeSmallImagePath: '/images/visage-verified/badge_small.png',
    badgeLargeImagePath: '/images/visage-verified/badge_72.png',
    badgeAspectRatio: 14 / 16,

    approvedGuildIds: [
      1283484, // Dsylxeic	https://raider.io/guilds/us/dalaran/Dsylxeic/
      9217, // Denial of Service	https://raider.io/guilds/us/burning-blade/Denial%20of%20Service
      7755, // ENTROPI	https://raider.io/guilds/us/zuljin/Entropi
      1088860, // Evilminded	https://raider.io/guilds/eu/tarren-mill/Evilminded
      27535, // Euphoric	https://raider.io/guilds/us/stonemaul/Euphoric
      1468742, // Student Council	https://raider.io/guilds/eu/twisting-nether/Student%20Council
      1615095, // C A L A M I T Y	https://raider.io/guilds/us/thrall/C%20A%20L%20A%20M%20I%20T%20Y
      11558, // Ministry of Defense	https://raider.io/guilds/us/aerie-peak/Ministry%20of%20Defense
      664024, // The Midnight Amendments	https://raider.io/guilds/us/proudmoore/The%20Midnight%20Amendments
      1789177, // Éléments	https://raider.io/guilds/eu/hyjal/Éléments/
      45059, // Propaganda 	https://raider.io/guilds/us/thrall/Propaganda
      1267655, // eGirls for Hire	https://raider.io/guilds/us/tichondrius/eGirls%20For%20Hire
      1767269, // https://raider.io/guilds/us/proudmoore/Eternal%20Kingdom%20Horde
      149425, // Eclipsis https://raider.io/guilds/us/wyrmrest-accord/Eclipsis
      1780728, // Optics https://raider.io/guilds/us/stormrage/Optics
      1578646, // Glorified Paperweight https://raider.io/guilds/eu/tarren-mill/Glorified%20Paperweight
      1814287, // All Nuke Skull https://raider.io/guilds/eu/ravencrest/All%20Nuke%20Skull
      1702848, // Syndicated https://raider.io/guilds/us/illidan/Syndicated
      1044443, // March of the Murlocs https://raider.io/guilds/eu/tarren-mill/March%20of%20the%20Murlocs
      1017528, // Healer Might Be Drunk https://raider.io/guilds/us/burning-legion/Healer%20Might%20Be%20Drunk
      1720428, // DAYGLOW https://raider.io/guilds/us/illidan/DAYGLOW
      1722584, // Daybreak https://raider.io/guilds/us/zuljin/Daybreak
      1783, // Seraph https://raider.io/guilds/us/malganis/Seraph,
      1362520, // Whisper https://raider.io/guilds/us/wyrmrest-accord/Whisper
      103401, // Voljins Bookclub https://raider.io/guilds/us/thrall/Voljins%20Bookclub
      131603, // Daydreamers https://raider.io/guilds/us/wyrmrest-accord/Daydreamers
      1609160, // Sharon https://raider.io/guilds/us/malganis/Sharon
      37465, // Empirical https://raider.io/guilds/us/madoran/Empirical
      941175, // Achievement https://raider.io/guilds/us/wyrmrest-accord/Achievement
      138724, // Battle Scars https://raider.io/guilds/eu/twisting-nether/Battle%20Scars
      1683871, // The Pancake Factory https://raider.io/guilds/eu/twisting-nether/The%20Pancake%20Factory
      1544234, // Review the Data https://raider.io/guilds/us/tichondrius/Review%20The%20Data
      1223820, // Valhalla https://raider.io/guilds/us/khazgoroth/Valhalla
      1848476, // Valhalla Berserkers https://raider.io/guilds/us/khazgoroth/Valhalla%20Berserkers
      1801788, // Valhälla https://raider.io/guilds/us/frostmourne/Valh%C3%A4lla
      1753628, // Valhälla https://raider.io/guilds/us/barthilas/Valh%C3%A4lla
      1716147, // Valhälla https://raider.io/guilds/us/khazgoroth/Valh%C3%A4lla
      1672264, // Valhallà https://raider.io/guilds/us/khazgoroth/Valhall%C3%A0
      605361, // The Pirates of Azeroth https://raider.io/guilds/eu/draenor/The%20Pirates%20of%20Azeroth
      1172945, // Undaunted https://raider.io/guilds/us/area-52/Undaunted
      913655, // Undaunted https://raider.io/guilds/eu/draenor/Undaunted
      1537739, // The Alphabet Maphia https://raider.io/guilds/us/frostmourne/The%20Alphabet%20Mafia
      1821541, // Minor Mutiny https://raider.io/guilds/us/illidan/Minor%20Mutiny
      1674968, // Wanderlust https://raider.io/guilds/us/zuljin/Wanderlust
      1702381, // Renewal Gaming https://raider.io/guilds/us/illidan/Renewal%20Gaming
      1722223, // IRONFIST https://raider.io/guilds/us/illidan/IRONFIST
      59501, // Land Raiders https://raider.io/guilds/us/silver-hand/Land%20Raiders
      876765, // Puzzle Box https://raider.io/guilds/us/wyrmrest-accord/Puzzle%20Box
      1268428, // Drama https://raider.io/guilds/eu/tarren-mill/Drama
      887827, // Conclave of Cool https://raider.io/guilds/us/emerald-dream/Conclave%20Of%20Cool
      1757189, // Walk In Get Loot https://raider.io/guilds/us/area-52/Walk%20In%20Get%20Loot
      1403833, // Elixir https://raider.io/guilds/us/moon-guard/Elixir
      1911438, // Our Captain is a Dragon https://raider.io/guilds/us/dunemaul/Our%20Captain%20Is%20A%20Dragon
      1633139, // MYTHICC https://raider.io/guilds/us/malganis/MYTHICC
      1891212, // The Brain Cell https://raider.io/guilds/us/wyrmrest-accord/The%20Brain%20Cell
      1351823, // Happy Tree Friends https://raider.io/guilds/us/stormrage/Happy%20Tree%20Friends
      1679402, // Remnants of Hope https://raider.io/guilds/us/illidan/The%20Remnants%20of%20Hope
      1140197, // Blackheart Accord https://raider.io/guilds/us/wyrmrest-accord/Blackheart%20Accord
      1653110, // Hungry for Apples https://raider.io/guilds/us/zuljin/Hungry%20for%20Apples
      1851116, // Justice https://raider.io/guilds/us/area-52/Justice
      1707866, // Trial Version https://raider.io/guilds/eu/tarren-mill/Trial%20Version
      49061, // Insurrection https://raider.io/guilds/us/kargath/Insurrection
      1817711, // Big Happy Gamers https://raider.io/guilds/us/illidan/Big%20Happy%20Gamers
      1967110, // Adjust https://raider.io/guilds/us/moon-guard/Adjust
      1354717, // The Gaymers https://raider.io/guilds/us/malganis/The%20Gaymers
      1000849, // Wayward Trading Co https://raider.io/guilds/us/wyrmrest-accord/Wayward%20Trading%20Co
      1293470, // Tab Target https://raider.io/guilds/us/tichondrius/Tab%20Target
      1986006, // Virtu https://raider.io/guilds/us/area-52/Virtu
      1310176, // Hierarchy https://raider.io/guilds/us/proudmoore/Hierarchy
      1251173, // The Hedgehugs https://raider.io/guilds/us/dalaran/The%20Hedgehugs
      1913776, // Mythics Managed https://raider.io/guilds/us/proudmoore/Mythics%20Managed
      1870201, // Thunderbolt Clan https://raider.io/guilds/eu/die-nachtwache/Thunderbolt%20Clan
      1841074, // Reminisce https://raider.io/guilds/us/moon-guard/Reminisce
      1900724, // Panic In The Discord https://raider.io/guilds/us/stormrage/Panic%20in%20the%20Discord
      1889688, // dead on my screen https://raider.io/guilds/us/tichondrius/dead%20on%20my%20screen
      1299899, // Canada https://raider.io/guilds/us/sargeras/Canada
      1733216, // Added https://raider.io/guilds/eu/antonidas/Added
      1153557, // Quake Star https://raider.io/guilds/us/stormrage/Quake%20Star
      1925098, // Blood Moon Pack and Den https://raider.io/guilds/us/hakkar/Blood%20Moon%20Pack%20and%20Den
      1913093, // The Dinosaur Illuminati https://raider.io/guilds/us/stormrage/The%20Dinosaur%20Illuminati
      1932657, // Synonym ROlls https://raider.io/guilds/eu/silvermoon/Synonym%20Rolls
      1644765, // Ministry of Silly Wipes https://raider.io/guilds/eu/bloodscalp/Ministry%20of%20Silly%20Wipes
      1912273, // Current https://raider.io/guilds/us/area-52/Current
      999067, // Hiraeth https://raider.io/guilds/eu/draenor/Hiraeth
      2008882, // Gray Parse https://raider.io/guilds/us/thrall/Gray%20Parse
      24749, // Aegis https://raider.io/guilds/us/galakrond/Aegis
      1944564, // Soup Squad https://raider.io/guilds/us/proudmoore/Soup%20Squad
      143219, // Final Contact https://raider.io/guilds/eu/antonidas/Final%20Contact
      389659, // Foolish Mortals https://raider.io/guilds/us/thrall/Foolish%20Mortals
      1558507, // Friend Raid https://raider.io/guilds/us/stormrage/Friend%20Raid
      1752825, // Pugs Placehttps://raider.io/guilds/us/kelthuzad/Pugs%20Place
      1970796, // Faîth https://raider.io/guilds/eu/antonidas/Fa%C3%AEth
      187315, // Noble House https://raider.io/guilds/us/emerald-dream/Noble%20House
      1704880, // https://raider.io/guilds/us/area-52/Functional
      562452, // https://raider.io/guilds/us/stormrage/Tilted%20Halos
      2021030, // https://raider.io/guilds/eu/aszune/Dungeon%20Dojo
      1736795, // https://raider.io/guilds/us/azralon/Revoada%20Noturna
      1997474, // https://raider.io/guilds/us/emerald-dream/quacks/
      1827785, // https://raider.io/guilds/us/zuljin/Good%20Soup
      1283582, // https://raider.io/guilds/us/tichondrius/Mysterious%20Intent
      1715125, // https://raider.io/guilds/us/tichondrius/IdSapThat
      1920111, // https://raider.io/guilds/eu/pozzo-delleternit%C3%A0/Forgotten%20Tales
      2009216, // https://raider.io/guilds/us/blood-furnace/Innkeepers%20Rest
      19483, // https://raider.io/guilds/us/amanthul/Oceania
      1724426, // https://raider.io/guilds/eu/antonidas/First%20We%20Feast
      148844, // https://raider.io/guilds/us/bloodscalp/No%20Good%20Deed
      1890751, // https://raider.io/guilds/us/moon-guard/The%20Major%20Arcana
      1970929, // https://raider.io/guilds/us/illidan/THIS%20IS%20WHY
      2045940, // https://raider.io/guilds/us/stormrage/The%20Cult%20Of%20Cheese
      1061868, // https://raider.io/guilds/eu/argent-dawn/Steadfast
      2011947, // https://raider.io/guilds/us/wyrmrest-accord/Firelink%20Shrine
      913668, // https://raider.io/guilds/us/barthilas/Bunnings%20Carehouse
      2064986, // https://raider.io/guilds/us/proudmoore/Spiral
      2030477, // https://raider.io/guilds/us/proudmoore/Real%20Dino%20Damage
      1802652, // https://raider.io/guilds/eu/silvermoon/Conundrum
      78162, // https://era.raider.io/guilds/us/dreamscythe/Hearth
      1921886, // https://raider.io/guilds/us/garona/Spectrum%20Federation
      1875362, // https://raider.io/guilds/eu/kazzak/Unicorns%20in%20Suits
      2008726, // https://raider.io/guilds/us/illidan/Outer%20Wilds
      85729, // https://raider.io/guilds/us/wyrmrest-accord/Vindicated
      2124635, // https://raider.io/guilds/us/stormrage/Falcon%20Shield
      2074570 // https://raider.io/guilds/us/illidan/Very%20Demure
    ]
  }
];
